import React, { useEffect, useState } from 'react';

import './index.css';

import { validate } from '../../utils/formValidation';

const generateFormValues = (formData, initialData) => {
  return formData.reduce((res, data) => {
    return {
      ...res, 
      [data.name]: initialData ? initialData[data.name] : ''
    }
  }, {})
}

const generateFormErrors = formData => {
  return formData.reduce((res, data) => {
    return {
      ...res, 
      [data.name]: ''
    }
  }, {})
}

const generateInputRules = formData => {
  return formData.reduce((res, data) => {
    return {
      ...res,
      [data.name]: data.validation
    }
  }, {})
}

const BaseForm = (props) => {
  const [formValues, setFormValues] = useState(generateFormValues(props.formData, props.initialData));
  const [formErrors, setFormErrors] = useState(generateFormErrors(props.formData))
  const [validFormValues, setValidFormValues] = useState({...formValues});
  const inputRules = generateInputRules(props.formData);

  useEffect(() => {
    const formValues = generateFormValues(props.formData, props.initialData);
    setFormValues(formValues);
    setValidFormValues(formValues);
  }, [props.initialData])

  const updateField = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value
    });
  }

  const validateField = async (e, input) => {
    //Synthetic event pooling.
    const inputName = e.target.name;
    const inputValue = e.target.value;

    try {
      validate(inputValue, inputRules[inputName], input.labelName);
      setFormErrors({
        ...formErrors,
        [inputName]: ''
      })
      
      if (props.actionsData && validFormValues[inputName] !== inputValue) {
        let action = props.actionsData[inputName];
        if (!action) {
          action = props.actionsData.other;
        }
        const response = await action({
          ...validFormValues,
          [inputName]: inputValue
        });
        if (response && response.data.status === 'failed') {
          //eslint-disable-next-line
          throw {message: 'This email is already in use'}
        }
      }

      setValidFormValues({
        ...validFormValues,
        [inputName]: inputValue
      })

    } catch (error) {
      setFormErrors({
        ...formErrors,
        [inputName]: error.message
      })
    }
  }

  const form = (
    <form 
      className="base-form__form"
      onSubmit={props.onSubmit ? () => props.onSubmit(formValues) : null}
    >
      {
        props.formData.map(input => {
          return (
            <div 
              className="base-form__form-group"
              key={input.name}
            >
              <label 
                className="base-form__label" 
                htmlFor={input.name}
              >
                {input.labelName}
              </label>
              <input 
                className={`base-form__input ${formErrors[input.name] ? 'base-form__input--invalid' : ''}`} 
                id={input.name} 
                type={input.type} 
                value={formValues[input.name]} 
                name={input.name} 
                onChange={updateField}
                onBlur={props.readOnly ? null : (e) => validateField(e, input)}
                readOnly={props.readOnly}
              />
              {
                formErrors[input.name] &&
                <span className="base-form__error">{formErrors[input.name]}</span>
              }
            </div>
          )
        })  
      }
      {props.children}
    </form>
  )

  return (
    props.formOnly ? (form) : (
      <div className={`base-form ${props.className ? props.className : ''}`}>
        {props.title &&
          <h3 className="base-form__title">
            {props.title}
          </h3>
        }
        {form}
      </div>  
    )
  );
}

export default BaseForm;